import React from "react"
import Navbar from "../../Common/Components/Navbar"
import Footer from "../../Common/Components/Footer"
import Sidebar from "../../Sidebar/Sidebar"
import ReleaseNoteComp from "./Component/ReleaseNoteComp"


const ReleaseNote =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ReleaseNoteComp />
        </div>
        <Footer />
        </>
    )
}

export default ReleaseNote